import * as Api from '@ViewModels';
import { ContactViewModel } from '@ViewModels';
import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { EntityDonations } from '../donations/EntityDonations';
import { EntityMatters } from '../matters/EntityMatters';
import { EntityOpportunities } from '../opportunities/EntityOpportunities';
import { EntityPolicies } from '../policies/EntityPolicies';
import { EntityServiceJobs } from '../serviceJobs/EntityServiceJobs';
import { styleSheet } from './styles';

export const EntityDataBoards = observer(({ entityViewModel }: { entityViewModel: Api.EntityViewModel }) => {
	const userSession = useUserSession();
	const entity = entityViewModel.toJs();

	const { policiesEnabled, donationsEnabled, opportunitiesEnabled, matterBoard, serviceJobBoard } =
		userSession.account.features?.boards ?? {};
	const mattersEnabled = matterBoard?.enabled;
	const serviceJobsEnabled = serviceJobBoard?.enabled;

	const isContactMode = entityViewModel instanceof ContactViewModel;

	return (
		<div className={css(styleSheet.container)}>
			{opportunitiesEnabled ? <EntityOpportunities entity={entity} isContactMode={isContactMode} /> : null}

			{donationsEnabled ? <EntityDonations entity={entity} mode={isContactMode ? 'contact' : 'company'} /> : null}

			{/* Policies, matters, and service jobs are contact-scoped only - they have no company-level
			    equivalent to roll up to yet, so they stay off the company profile. */}
			{policiesEnabled && isContactMode ? <EntityPolicies entity={entity} /> : null}

			{mattersEnabled && isContactMode ? <EntityMatters entity={entity} /> : null}

			{serviceJobsEnabled && isContactMode ? <EntityServiceJobs entity={entity} /> : null}
		</div>
	);
});

export const anyDataBoardEnabledForCompany = (userSession: Api.UserSessionContext) => {
	const { donationsEnabled, opportunitiesEnabled } = userSession.account.features?.boards ?? {};
	return !!donationsEnabled || !!opportunitiesEnabled;
};
